import React, { useRef, useEffect } from 'react';
import MessageItem from './MessageItem';

const ChatMessages = ({ messages, isBotTyping, onSuggestedActionClick }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isBotTyping]);

  return (
    <div className="w-full max-w-[800px] max-h-[300px] sm:max-h-[400px] overflow-y-auto my-4 sm:my-5 rounded-2xl transition-all duration-300 ease-in-out scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent animate-fadeIn px-2 sm:px-0" style={{ background: '#f9fafb', boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.04)' }}>
      <div className="p-3 sm:p-5 flex flex-col">
        {messages.map((message, index) => (
          <MessageItem 
            key={index} 
            message={message} 
            onSuggestedActionClick={onSuggestedActionClick}
          />
        ))}
        
        {isBotTyping && (
          <div className="flex items-center gap-1 p-[10px_16px] rounded-2xl w-fit self-start" style={{ background: '#f3f4f6', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
            <span className="w-2 h-2 rounded-full animate-typing-dot [animation-delay:-0.32s]" style={{ background: 'var(--color-primary)', opacity: 0.7 }}></span>
            <span className="w-2 h-2 rounded-full animate-typing-dot [animation-delay:-0.16s]" style={{ background: 'var(--color-primary)', opacity: 0.7 }}></span>
            <span className="w-2 h-2 rounded-full animate-typing-dot" style={{ background: 'var(--color-primary)', opacity: 0.7 }}></span>
          </div>
        )}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatMessages;